import { styled } from '@mui/system';
import { FC, useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';

// Styled components using MUI's styled API
const ColorDiv = styled('div')({
  width: '36px',
  height: '14px',
  borderRadius: '1px',
});

const SwatchDiv = styled('div')({
  padding: '5px',
  background: '#fff',
  borderRadius: '1px',
  boxShadow: '0 0 0 1px rgba(0, 0, 0, .2)',
  display: 'inline-block',
  cursor: 'pointer',
});

const PopoverDiv = styled('div')({
  position: 'absolute',
  zIndex: 2,
});

const CoverDiv = styled('div')({
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
});

// Define the props type
interface ColorPickerInputProps {
  value: string;
  setColor: (color: string) => void;
  label: string;
}

// Functional component with TypeScript
const ColorPickerInput: FC<ColorPickerInputProps> = ({
  value,
  setColor,
  label,
}) => {
  const [color, setColorState] = useState<string>(value);
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color: ColorResult) => {
    setColorState(color.hex);
    setColor(color.hex);
  };

  return (
    <div className="flex-center-align" style={{ marginTop: 10 }}>
      <label htmlFor="textAlignSelect">{label}</label>
      <div style={{ marginLeft: 5, paddingTop: 5 }}>
        <SwatchDiv onClick={handleClick}>
          <ColorDiv style={{ background: color }} />
        </SwatchDiv>
        {displayColorPicker ? (
          <PopoverDiv>
            <CoverDiv onClick={handleClose} />
            <SketchPicker color={color} onChange={handleChange} />
          </PopoverDiv>
        ) : null}
      </div>
    </div>
  );
};

export default ColorPickerInput;
